var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2898 11.0879L10.5108 9.29715L12.2888 7.50644C12.6308 7.163 12.6308 6.60404 12.2888 6.2606C11.9468 5.91414 11.3938 5.91515 11.0518 6.25959L9.27276 8.0503L7.49375 6.25758C7.15175 5.91313 6.59775 5.91515 6.25575 6.25758C5.91475 6.60202 5.91475 7.16099 6.25575 7.50443L8.03575 9.29715L6.25975 11.0848C5.91775 11.4293 5.91775 11.9882 6.25975 12.3307C6.43075 12.5039 6.65375 12.5895 6.87775 12.5895C7.10275 12.5895 7.32575 12.5039 7.49675 12.3317L9.27276 10.543L11.0528 12.3347C11.2238 12.5069 11.4468 12.5925 11.6708 12.5925C11.8948 12.5925 12.1188 12.5059 12.2898 12.3347C12.6318 11.9903 12.6318 11.4323 12.2898 11.0879Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelEditor);
export default __webpack_public_path__ + "static/media/cancel-editor.f37be5e5440b81ac95bce4cbc9cfec06.svg";
export { ForwardRef as ReactComponent };